import {CheckCircleFillIcon} from '@primer/octicons-react'
import {mergeabilityStatus, Status} from '@github-ui/mergebox/helpers/mergeability-status'
import {ForYouItem} from '../shared/ForYouItem'
import {ForYouLeadingIcon} from '../shared/ForYouLeadingIcon'
import {useMergeabilityData} from './use-mergeability-data'
import {OverviewMergeControl} from './shared/OverviewMergeControl'

export function shouldShowAbleToMerge(data: ReturnType<typeof useMergeabilityData>) {
  if (!data) return false

  const {mergeBoxPullRequest, mergeRequirements, statusChecksData} = data
  const status = mergeabilityStatus({
    pullRequest: mergeBoxPullRequest,
    mergeRequirements,
    statusChecksData,
  })
  const mergeRequirementsSatisfied =
    mergeRequirements?.state === 'MERGEABLE' || mergeRequirements?.state === 'MERGEABLE_IF_STATUSES_PASS'

  return mergeRequirementsSatisfied && status === Status.NonRequiredChecksUnsuccessful
}

export function AbleToMerge({variant}: {variant?: 'default' | 'embedded'}) {
  const data = useMergeabilityData()

  if (!shouldShowAbleToMerge(data)) return null

  return (
    <ForYouItem
      leadingVisual={<ForYouLeadingIcon icon={CheckCircleFillIcon} emphasized />}
      emphasizedLeadingVisual
      title="Checks failing"
      itemName="able-to-merge"
      variant={variant}
      description="Some non-required checks are failing"
      actionSlot={<OverviewMergeControl data={data} itemName="able-to-merge" />}
    />
  )
}
